import 'babel-polyfill'

import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'
import vuetify from '@/plugins/vuetify'

require('./bootstrap')
require('@/plugins/registerComponents')

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.mixin({ methods: { route: window.route } })
Vue.use(InertiaPlugin)
Vue.use(PortalVue)
Vue.use(VueMeta)

InertiaProgress.init()

const app = document.getElementById('app')

const eventBus = new Vue()
window.eventBus = eventBus

window.App = new Vue({
   vuetify,
   metaInfo: {
      title: 'Loading...',
      titleTemplate: '%s • Vertriebstool Telekom',
      changed (info) {
         window.App.goBack = info.goBack
         window.App.appTitle = info.titleChunk
      }
   },
   data: vm => ({
      appTitle: 'Loading...',
      goBack: null,
      drawer: null,
      flashSnackbar: false,
      flashMessage: '',
   }),

   mounted () {
      eventBus.$on('flashMessage', (value) => {
         this.flashMessage = value
         this.flashSnackbar = true
      })
   },
   render: h => h(InertiaApp, {
      props: {
         initialPage: JSON.parse(app.dataset.page),
         resolveComponent: (name) => require(`./Pages/${name}`).default,
         transformProps: props => {
            if (props.jetstream.flash.success) {
               eventBus.$emit('flashMessage', props.jetstream.flash.success)
            }
            return props
         },
      },
   }),
}).$mount(app)
